import { motion } from "framer-motion";

const STEPS = ["ESTABLISHING UPLINK", "EARTH TEXTURES", "SATELLITE MODEL", "AIRFRAME SPLATS", "CALIBRATING OPTICS"];

export const Loader = ({ progress, done }) => {
  const step = Math.min(STEPS.length - 1, Math.floor(progress * STEPS.length));
  return (
    <motion.div
      data-testid="scene-loader"
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#070A0F]"
      initial={{ opacity: 1 }}
      animate={done ? { opacity: 0 } : { opacity: 1 }}
      transition={{ duration: 1, ease: "easeInOut" }}
      onAnimationComplete={() => { if (done) { const el = document.querySelector('[data-testid="scene-loader"]'); if (el) el.style.display = "none"; } }}
    >
      <div className="relative mb-10 h-20 w-20" aria-hidden="true">
        <svg viewBox="0 0 80 80" className="orbit-spin absolute inset-0 h-full w-full">
          <ellipse cx="40" cy="40" rx="34" ry="13" fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="1.4" />
        </svg>
        <svg viewBox="0 0 80 80" className="orbit-spin-b absolute inset-0 h-full w-full">
          <ellipse cx="40" cy="40" rx="26" ry="26" fill="none" stroke="rgba(255,138,43,0.55)" strokeWidth="1.2" strokeDasharray="4 7" />
        </svg>
        <span className="absolute left-1/2 top-1/2 h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#FF8A2B]" />
      </div>
      <p className="font-mono pl-[0.28em] text-base font-medium tracking-[0.34em] text-white">PMP</p>
      <div className="mt-8 h-px w-56 overflow-hidden bg-white/15">
        <motion.div style={{ scaleX: progress }} className="h-full w-full origin-left bg-[#FF8A2B] transition-transform duration-500 ease-out" />
      </div>
      <p data-testid="loader-status" className="mt-5 font-mono text-[10px] tracking-[0.3em] text-white/60">
        {STEPS[step]} — {Math.round(progress * 100)}%
      </p>
    </motion.div>
  );
};
